var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Endpoint } from 'app/stores/common';
import { publishSlice } from 'app/stores/publish';
import { PlatformType } from 'app/views/components/dialogs/publish/platform';
import { rasterizeProjectAction } from '../../project/actions/rasterize';
export const publishToAnnotely = createAsyncThunk('publish/annotely', (opts, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const exportPackage = opts.strategy === 'all_pages';
    try {
        dispatch(publishSlice.actions.setJobState({
            platform: PlatformType.Annotely,
            state: 'publishing',
            startedAt: Date.now(),
        }));
        const rasterizeProjectParams = {
            format: 'image/jpeg',
            strategy: opts.strategy,
            mangleFilenames: exportPackage,
            generateManifest: exportPackage,
            compress: false,
        };
        const output = yield dispatch(rasterizeProjectAction(rasterizeProjectParams)).unwrap();
        if (!output) {
            throw new Error('Invalid data');
        }
        const publishInfo = yield fetch(Endpoint.shared.publish(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                files: output.map(({ name, data }) => ({
                    name,
                    type: data.type,
                    size: data.size,
                })),
            }),
        }).then(response => response.json());
        const { url, requests } = publishInfo;
        const fileUrls = requests.reduce((accum, request) => accum.set(request.name, request.url), new Map());
        yield Promise.all(output.map(render => {
            const uploadUrl = fileUrls.get(render.name);
            return fetch(uploadUrl, {
                method: 'PUT',
                body: render.data,
            });
        }));
        dispatch(publishSlice.actions.setJobState({
            platform: PlatformType.Annotely,
            state: 'published',
            publishedAt: Date.now(),
            name: publishInfo.prefix,
            url,
        }));
    }
    catch (err) {
        getLogger('PlatformPublish', 'error')(err);
        const reason = err instanceof Error ? err.message : 'n/a';
        dispatch(publishSlice.actions.setJobState({
            platform: PlatformType.Annotely,
            state: 'error',
            message: `Platform publish error; reason=${reason}`,
        }));
    }
}));
